'use client';

import { Children, cloneElement, ComponentElement } from 'react';

import { useMenuContext } from './MenuProvider';

import type { MenuProps } from '@mui/material';
import type { FC, HTMLAttributes, ReactElement } from 'react';

export interface MenuOnClickCloseProps extends Partial<MenuProps> {
  children: ReactElement<HTMLAttributes<HTMLElement>>;
}

export const MenuOnClickClose: FC<MenuOnClickCloseProps> = ({
  children,
  ...props
}) => {
  const { onClose } = useMenuContext();

  return Children.map(
    children,
    (child, index) =>
      cloneElement<HTMLAttributes<HTMLElement>>( child, {
        onClick: (e) => {
          onClose( e );
          child.props.onClick?.( e );
        },
        key: index,
        ...props,
      } )
  );
};
